<template>
    <section>
        <button v-b-modal.services class="btn btn-primary">Voir les prestations</button>
        <b-modal id="services"  size="lg" hide-footer>
            <b-card class="p-2" no-body>
                <div class="row m-4 d-flex justify-content-between">
                    <h4>Toutes nos prestations</h4>
                    <div v-if="allService" class="text-right">
                        <div class="input-group">
                            <input v-model="inputSearch"  @keyup="searchService()" class="form-control" id="navbar-search-input" placeholder="Rechercher un service" aria-label="search" aria-describedby="search">
                            <div class="input-group-append">
                                <button type="submit" class="input-group-text"><i class="fa fa-search icon-sm"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <b-tabs class="computer" pills card vertical nav-wrapper-class="w-50">
                    <b-tab title="Tous" @click="allService =true">
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in searchServiceResult" :key="index">
                                <div class="row">
                                    <div class="col-md-6">{{item.name}}</div>
                                    <div class="col-md-3">{{convertToTime(item.duration)}}</div>
                                    <div class="col-md-3" style="text-align:right">{{item.price}} €</div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                    <b-tab  @click="allService =false" :title="item.category"  v-for="(item, index) in categorie" :key="index" >
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in item.services" :key="index">
                                <div class="row">
                                    <div class="col-md-6">{{item.name}}</div>
                                    <div class="col-md-3">{{convertToTime(item.duration)}}</div>
                                    <div class="col-md-3" style="text-align:right">{{item.price}} €</div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                </b-tabs>
                <b-tabs class="mobile tab-solid tab-solid-danger">
                    <b-tab title="Tous" @click="allService =true">
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in searchServiceResult" :key="index">
                                <div class="row">
                                    <div class="col-md-6">{{item.name}}</div>
                                    <div class="col-md-3">{{convertToTime(item.duration)}}</div>
                                    <div class="col-md-3" style="text-align:right">{{item.price}} €</div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                    <b-tab  @click="allService =false" :title="item.category"  v-for="(item, index) in categorie" :key="index" >
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in item.services" :key="index">
                                <div class="row">
                                    <div class="col-md-6">{{item.name}}</div>
                                    <div class="col-md-3">{{convertToTime(item.duration)}}</div>
                                    <div class="col-md-3" style="text-align:right">{{item.price}} €</div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                </b-tabs>
            </b-card>
            <hr>
        </b-modal>
    </section>
</template>
<script>
import axios from 'axios'

export default {
    name: 'show-services',
    data () {
        return {
            selectedService: null,
            inputSearch:'',
            searchServiceResult:null,
            allService:true,
            categorie:null,
            services:null,
        }
    },
    methods:{
        getCategories(){
            let url = "categories"
            axios.get(url)
                .then(
                    resgetcategories => {
                        this.categorie = resgetcategories.data.result

                    }
                )
                .catch(
                    errgetProducts => {
                        console.log(errgetProducts)
                    }
                )
        },
        getService(){
            let url ="services"
            axios.get(url)
                .then(
                    resgetService => {
                        this.services = resgetService.data.result
                        this.searchServiceResult =this.services
                    }
                )
                .catch(
                    errgetProducts => {
                        console.log(errgetProducts)
                    }
                )
        },
        searchService()
        {
            this.searchServiceResult=null
            this.currentPage = 1
            const regex = new RegExp(this.inputSearch.toLowerCase());
            let newservice = []
            // if (this.filtrekey == "") {
            // // newproduct = this.products
            // }
            this.services.forEach(element => {
                if(regex.test(element.name.toLowerCase())){
                    newservice.push(element)
                }
            })
            this.searchServiceResult = newservice
        },
        convertToTime(duration){
            var sec = 3600 * duration
            var date = new Date(0);
            date.setSeconds(sec);
            var timeString = date.toISOString().substr(11, 8);
            return timeString
        }
    },
    mounted(){
        this.getCategories()
        this.getService()
    }
}
</script>
<style scoped>
::v-deep .tab-pane.active {
    max-height: 70vh;
    overflow: auto;
}
::v-deep .tab-solid-danger .nav-link.active{
    background: #c09b27;
    color: #fff;
}
::v-deep .nav-pills .nav-link.active, .nav-pills .show > .nav-link{
    background-color: #c09b27 !important;
    color: #fff;
}
</style>